import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mq } from 'styles/mixins';
import { THEME } from '../../../common/consts/theme';

type PageType = {
  isActive: boolean;
};

type ArrowPathType = {
  isActive: boolean;
};

export const Wrapper = styled.ul`
  display: flex;
  margin-top: 2.5rem;
  margin-bottom: 5rem;
  padding: 0;

  ${mq.xLarge(css`
    margin-bottom: 7.5rem;
  `)};
`;

export const Page = styled.li<PageType>`
  display: flex;
  width: 3rem;
  height: 3rem;
  border: 0.0625rem solid #d8dfe4;
  border-radius: 3.75rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.font.questrial};
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 1.875rem;
  margin-right: 1rem;
  cursor: pointer;
  transition: box-shadow 200ms ease-in-out;

  &:hover {
    box-shadow: 0.5rem 0.5rem 1.5rem 0 #1700594a;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-color: ${THEME.colors.primary};

      &:hover {
        box-shadow: none;
      }
    `};
`;

export const Dots = styled.li`
  margin-right: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PaginationArrow = styled.li`
  width: 3rem;
  height: 3rem;
  border: 0.0625rem solid #d8dfe4;
  box-sizing: border-box;
  border-radius: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ArrowPath = styled.path<ArrowPathType>`
  ${({ isActive }) =>
    isActive &&
    css`
      stroke: ${THEME.colors.black};
    `};
`;

export const PaginationArrowBack = styled(PaginationArrow)`
  margin-right: 1rem;
`;
